export default __webpack_public_path__ + "static/media/Diana-Banner-Download.beef8e70.png";